import styled from 'styled-components';
import { Section } from '../../Common/PageElement';
import { MD_FONT_SIZE, PRIMARY_COLOR, SECONDARY_COLOR, SEMI_FONT_WEIGHT, SM_FONT_SIZE, SM_PADDING, WHITE_COLOR } from '../../Common/StyleElement';

export const FeatureItem = styled.div`
    position: relative;
    display: grid;
    grid-template-columns: 75px auto;
    min-width: 0;
    word-wrap: break-word;
    margin-bottom: 1.5rem;
    padding: 1.25rem;
`

export const FeatureBody = styled.div`
    flex: 1 1 auto;
    min-height: 1px;
`

export const FeatureTitle = styled.div`
    font-weight: ${SEMI_FONT_WEIGHT};
    font-size: ${MD_FONT_SIZE};
    padding-bottom: ${SM_PADDING};
`

export const FeatureText = styled.p`
    margin-bottom: 0;
    font-size: ${SM_FONT_SIZE};
`

export const FeatureIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    border: 1px solid ${WHITE_COLOR};
`

export const FeatureSection = styled(Section)`
    background-color: ${PRIMARY_COLOR};
    background-image: linear-gradient(
        135deg,
        ${PRIMARY_COLOR} 0%,
        ${SECONDARY_COLOR} 100%
    );
    color: ${WHITE_COLOR};
    border-top: 0px;
    //-webkit-clip-path: polygon(0 0, 100% 0, 100% 80%, 0 100%);
    //clip-path: polygon(0 0, 100% 0, 100% 80%, 0 100%);
`